import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["hideLabel", "elementType"];
import { jsx } from 'react/jsx-runtime';
import { useMemo, forwardRef } from 'react';
import { Role } from '@ariakit/react';
import { useContextProps, LabelContext } from 'react-aria-components';
import { VisuallyHidden } from '../../visually-hidden/visually-hidden.js';

var useLabelable = function useLabelable(label, inputId) {
  return useMemo(function () {
    var Label = /*#__PURE__*/forwardRef(function (props, ref) {
      // If this component is rendered within LabelContext from RAC, we can have props like htmlFor, id, elementType.
      var _useContextProps = useContextProps(props, ref, LabelContext);

      var _useContextProps2 = _slicedToArray(_useContextProps, 2);

      props = _useContextProps2[0];
      ref = _useContextProps2[1];

      var _props = props,
          hideLabel = _props.hideLabel,
          _props$elementType = _props.elementType,
          elementType = _props$elementType === void 0 ? 'label' : _props$elementType,
          rest = _objectWithoutProperties(_props, _excluded);

      var labelProps = _objectSpread(_objectSpread({}, rest), {}, {
        htmlFor: inputId,
        ref: ref
      });

      if (!label) {
        return null;
      }

      if (typeof label === 'string') {
        if (elementType === 'label') {
          return hideLabel ? jsx(VisuallyHidden, {
            render: jsx(Role.label, _objectSpread(_objectSpread({}, labelProps), {}, {
              children: label
            }))
          }) : jsx(Role.label, _objectSpread(_objectSpread({}, labelProps), {}, {
            children: label
          }));
        }

        return hideLabel ? jsx(VisuallyHidden, {
          render: jsx(Role.span, _objectSpread(_objectSpread({}, rest), {}, {
            ref: ref,
            children: label
          }))
        }) : jsx(Role.span, _objectSpread(_objectSpread({}, rest), {}, {
          ref: ref,
          children: label
        }));
      }

      return elementType === 'label' ? jsx(Role.label, _objectSpread(_objectSpread({}, labelProps), {}, {
        // @ts-expect-error: Otherwise we have a conflict of HTMLAttributes and our Blueprint components props.
        render: hideLabel ? jsx(VisuallyHidden, {
          render: label
        }) : label
      })) : jsx(Role.span, _objectSpread(_objectSpread({}, rest), {}, {
        ref: ref,
        // @ts-expect-error: Otherwise we have a conflict of HTMLAttributes and our Blueprint components props.
        render: hideLabel ? jsx(VisuallyHidden, {
          render: label
        }) : label
      }));
    });
    Label.displayName = 'Label';
    return Label;
  }, [label, inputId]);
};

export { useLabelable };